import React from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { NavbarBig } from "./pages";
import HomePage from "./pages/HomePage";
import UnifiedProjectsPage from "./pages/UnifiedProjectsPage";
import ProjectDetailPage from "./pages/ProjectDetailPage";
import Project2025DetailPage from "./pages/Project2025DetailPage";
import Courses from "./pages/Courses";
import ScrollToTop from "./pages/ScrollToTop";
import "@fontsource/montserrat";
import "./index.css";

function App() {
  return (
    <BrowserRouter>
      <ScrollToTop />
      <div className="flex flex-col min-h-screen w-full">
        <NavbarBig />
        <main className="flex-grow">
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/projects" element={<UnifiedProjectsPage />} />
            <Route
              path="/projects/2024/:projectId"
              element={<ProjectDetailPage />}
            />
            <Route
              path="/projects/2025/:projectId"
              element={<Project2025DetailPage />}
            />
            <Route
              path="/projects/:projectId"
              element={<ProjectDetailPage />}
            />
            <Route path="/courses" element={<Courses />} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </main>
      </div>
    </BrowserRouter>
  );
}

export default App;
